import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { SymbolsService } from 'symbols/SymbolsService';

export type MarketDataRequestBarRequest = {
    type: 'barRequest';
    symbol: string;
    symbology: SymbologyValues;
    barSize: number;
};

export const buildBarRequest: (
    symbol: string,
    symbology: SymbologyValues,
    barSize: number
) => MarketDataRequestBarRequest = (symbol, symbology, barSize) => ({
    type: 'barRequest',
    symbology,
    symbol,
    barSize,
});

export interface MarketDataTickRequest {
    type: 'tickRequest';
    symbol: string;
    symbology: SymbologyValues;
}

export const buildTickRequest: (
    symbol: string,
    symbology: SymbologyValues
) => MarketDataTickRequest = (symbol, symbology) => ({
    type: 'tickRequest',
    symbol,
    symbology,
});

export type MarketDataRequest =
    | MarketDataRequestBarRequest
    | MarketDataTickRequest;

export type BloombergMarketDataRequest = MarketDataRequest & {
    /*
     * Bloomberg symbol
     */
    bbSymbol: string;
};

export function requestUid(request: BloombergMarketDataRequest) {
    if (request.type === 'barRequest') {
        const { bbSymbol, barSize } = request;
        return `Bar-${bbSymbol}-${barSize}`;
    } else {
        const { bbSymbol } = request;
        return `Tick-${bbSymbol}`;
    }
}

export function isTickRequest(
    request: MarketDataRequest
): request is MarketDataTickRequest {
    return request.type === 'tickRequest';
}

export function isBarRequest(
    request: MarketDataRequest
): request is MarketDataRequestBarRequest {
    return request.type === 'barRequest';
}

export function isBloombergTickRequest(
    request: BloombergMarketDataRequest
): request is MarketDataTickRequest & BloombergMarketDataRequest {
    return request.type === 'tickRequest';
}

export function isBloombergBarRequest(
    request: BloombergMarketDataRequest
): request is MarketDataRequestBarRequest & BloombergMarketDataRequest {
    return request.type === 'barRequest';
}

export async function mapToBloombergRequest(
    request: MarketDataRequest,
    symbolsService: SymbolsService
): Promise<BloombergMarketDataRequest | undefined> {
    const bbSymbol =
        (await symbolsService.convertSymbol(
            request.symbol,
            request.symbology,
            SymbologyValues.Bloomberg
        )) ?? '';

    return bbSymbol ? { ...request, bbSymbol } : undefined;
}
